import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import PageWelcomeBackHandler from '@/pages/account/welcome-back/handle'

export const Route = createFileRoute('/app/account/welcome-back/$token')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageWelcomeBackHandler />
}
